import { Component, OnInit, TemplateRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import {Sort} from '@angular/material/sort';
import {MatPaginator, MatSort, MatTableDataSource} from '@angular/material';
import { RestaurantServiceService } from '../../../restaurant/restaurant-service.service';

@Component({
  selector: 'app-scale-unit',
  templateUrl: './scale-unit.component.html',
  styleUrls: ['./scale-unit.component.scss']
})
export class ScaleUnitComponent implements OnInit {
  private id;
  private Id;
  modalRef: BsModalRef;
  p = 1;
  private mealId;
  countriesList: any [] ;
  sortedData: any [];
  addScaleUnitmodel: any = {};

  private restId;
  private menuId;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private modalService: BsModalService,
    private toastr: ToastrService,
    private restaurantServices: RestaurantServiceService
  ) { }

  ngOnInit() {
    this.id = this.route.snapshot.params['id'];
    this.mealId = this.route.snapshot.params['mealId'];

    this.restId = this.route.snapshot.params['restId'];
    this.menuId = this.route.snapshot.params['menuId'];
    this.getAllScaleUnit();

  }
  sortData(sort: Sort) {
    // const data = this.cities.slice();
    const data = this.countriesList.slice();
    if (!sort.active || sort.direction === '') {
      this.sortedData = data;
      return;
    }

    this.sortedData = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'Name': return compare(a.Value, b.Value, isAsc);

        default: return 0;
      }
    });
  }
  addScaleUnit() {
    this.addScaleUnitmodel.ScaleId = this.id;
    this.restaurantServices.CreateScaleUnit(this.addScaleUnitmodel).subscribe((Data: any) => {
      this.toastr.success('Unit added');
       if (!Data.id) {
        this.getAllScaleUnit();
       }
     });
     }
  getAllScaleUnit() {
      this.restaurantServices.getAllUnitByScaleId(this.id).subscribe(Response => {
        this.countriesList = Response;
        if (this.countriesList == null) {
        }
        console.log('Countries List', this.countriesList);
         this.sortedData = this.countriesList.slice();
      });
  }
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: 'modal-sm' });
  }

  confirm(id): void {
    this.restaurantServices.DeleteScaleUnit(id).subscribe(Response => {
      this.getAllScaleUnit();
    });
    this.modalRef.hide();
  }
  decline(): void {
    this.modalRef.hide();
  }
  UpdateScaleUnit(id) {
    // tslint:disable-next-line:max-line-length
    this.router.navigateByUrl('/mealDetail/updateScale/' + this.restId + '/' + this.menuId + '/' + this.mealId + '/' + this.id  + '/' + id);

  }
}
function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
